export function showElement(element) {
  element?.classList.remove("hidden")
}

export function hideElement(element) {
  element?.classList.add("hidden")
}

export function toggleElement(element) {
  element?.classList.toggle("hidden")
}
